export interface GalleryImage {
  id: string;
  src: string;
  alt: string;
  category: string;
}

export const galleryImages: GalleryImage[] = [
  {
    id: 'g1',
    src: 'https://static.readdy.ai/image/207d1fdbe5520f856773b12bb4c3bbee/afba8065016d507f2f8c8ff415707e60.jpeg',
    alt: 'Golden chai cup with saffron garnish on vibrant red table',
    category: 'Tea',
  },
  {
    id: 'g2',
    src: 'https://static.readdy.ai/image/207d1fdbe5520f856773b12bb4c3bbee/9aa69218a04b27dfbbca68cacfb5a286.jpeg',
    alt: 'Close-up of creamy karak chai with nut topping in gold-rimmed cup',
    category: 'Tea',
  },
  {
    id: 'g3',
    src: 'https://static.readdy.ai/image/207d1fdbe5520f856773b12bb4c3bbee/80a0788029abf61cb1c5c31a4c3feda5.jpeg',
    alt: 'Fresh parathas being prepared on a large flat griddle',
    category: 'Food',
  },
  {
    id: 'g4',
    src: 'https://static.readdy.ai/image/207d1fdbe5520f856773b12bb4c3bbee/2adbff2abb5784cde77892932d115f1e.jpeg',
    alt: 'Golden samosas with chai on a bright blue plate',
    category: 'Food',
  },
  {
    id: 'g5',
    src: 'https://static.readdy.ai/image/207d1fdbe5520f856773b12bb4c3bbee/4b60b7d2a78bd53f81769c14c116903f.jpeg',
    alt: 'Ghalib Chai premium green tea package held in hand over grass',
    category: 'Products',
  },
  {
    id: 'g6',
    src: 'https://readdy.ai/api/search-image?query=Cozy%20tea%20house%20interior%20with%20warm%20lighting%2C%20wooden%20furniture%2C%20soft%20cushions%2C%20plants%2C%20and%20tea%20cups%20on%20tables%2C%20warm%20inviting%20atmosphere%2C%20cultural%20elegance&width=800&height=600&seq=gallery-interior-01&orientation=landscape',
    alt: 'Warm and inviting tea house interior with elegant decor',
    category: 'Interior',
  },
  {
    id: 'g7',
    src: 'https://readdy.ai/api/search-image?query=Elegant%20tea%20serving%20tray%20with%20multiple%20tea%20cups%2C%20teapot%2C%20and%20pastries%20on%20a%20beautiful%20wooden%20table%2C%20warm%20natural%20lighting%2C%20premium%20tea%20service%20photography&width=800&height=600&seq=gallery-tea-01&orientation=landscape',
    alt: 'Elegant tea service tray with teapot and pastries',
    category: 'Tea',
  },
  {
    id: 'g8',
    src: 'https://readdy.ai/api/search-image?query=Loose%20green%20tea%20leaves%20in%20a%20beautiful%20ceramic%20bowl%20with%20wooden%20spoon%2C%20warm%20cream%20background%2C%20premium%20tea%20product%20photography%2C%20soft%20natural%20lighting&width=800&height=600&seq=gallery-green-01&orientation=landscape',
    alt: 'Loose green tea leaves in a ceramic bowl',
    category: 'Products',
  },
];